import TwoInputs from '../../../components/input_fields/TwoInputs';
import FormTitle from '../../../components/form_titles/FormTitle';
import DoubleButton from '../../../components/buttons/DoubleButton';
import ProgressBar from '../../../components/progress/ProgressBar';

import validator from "validator";
import React, { useState } from "react";
import ImageUpload from '../../../components/ImageUploader';

export default function Step4edit({ nextStep, handleFormData, changeVal, prevStep, values, validation }) {

  const [grossSalesError, setGrossSalesError] = useState(false)
  const [highestSaleError, setHighestSaleError] = useState(false)
  const [annualSalesError, setAnnualSalesError] = useState(false)
  const [avgSalesError, setAvgSalesError] = useState(false)
  const [checkImageError, setCheckImageError] = useState(false)

  // Image Upload
  const submitFormData = (e) => {
    e.preventDefault()

    if (validation) {
      //Gross Sales Error
      if (!validator.isNumeric(values.grossSales)) {
        setGrossSalesError(true)
        return
      } setGrossSalesError(false)

      //Highest Sale Error
      if (!validator.isNumeric(values.highestSale)) {
        setHighestSaleError(true)
        return
      } setHighestSaleError(false)

      //Annual Sales Error
      if (!validator.isNumeric(values.annualSales)) {
        setAnnualSalesError(true)
        return
      } setAnnualSalesError(false)

      //Average Sales Error
      if (!validator.isNumeric(values.avgSales)) {
        setAvgSalesError(true)
        return
      } setAvgSalesError(false)
    }

    nextStep()
  }

  // Remove Check Upload
  // Everything else stays

  // Share your business location
  // Then the loading circle (processing information)

  // ©2023 Coastal Acquiring Secure Holdings, LLC
  // 833 - bipsypay
  // Use the my cash7

  return (
    <div className="bg-white-900 dark:bg-white-900">
      <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0">
        {/* <ApplicationTitle 
            mainTitle = "Bipsypay Merchant Application"
            subTitle = "Complete the form below to begin your Bipsypay merchant application"
        /> */}
        <ProgressBar
          progress="48%"
        />
        <div className="bg-white rounded-lg shadow dark:border xl:p-0">
          <div className="p-6 space-y-1 sm:p-8">
            <FormTitle
              mainTitle="Show us the"
              colorTitle="money."
              subText="Estimated Company Sales Revenue & Credit Card Volume."
              modalTitle="Why do you need this..."
              modalDesc="Providing an accurate profile helps us 
                get you paid without delays. We pay 
                close attention to the average ticket 
                amount and high ticket amounts as one 
                way to counteract fraud. If you process 
                a transaction for an amount much 
                higher than your declared average ticket 
                amount you may be subject to penalties 
                such as having the funds from the 
                transaction held for undetermined 
                periods of time, having your account 
                closed, or both."
            />
            <form className="space-y-4" onSubmit={submitFormData}>
              <TwoInputs
                placeholder1="Total Annual Sales (Gross)" id1="gross_sales" name1="grossSales" type1="number" value1={values.grossSales}
                error1={grossSalesError} message1={"Please input a valid number."}
                handleInputChange1={handleFormData}
                placeholder2="Highest Credit Card Sale" id2="highest_sale" name2="highestSale" type2="number" value2={values.highestSale}
                error2={highestSaleError} message2={"Please input a valid number."}
                handleInputChange2={handleFormData}
              />
              <TwoInputs
                placeholder1="Annual Credit Card Sales" id1="annual_sales" name1="annualSales" type1="number" value1={values.annualSales}
                error1={annualSalesError} message1={"Please input a valid number."}
                handleInputChange1={handleFormData}
                placeholder2="AVG. Credit Card Sale Amount" id2="avg_sales" name2="avgSales" type2="number" value2={values.avgSales}
                error2={avgSalesError} message2={"Please input a valid number."}
                handleInputChange2={handleFormData}
              />

              <DoubleButton prevStep={prevStep}></DoubleButton>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}